import { Box, Slide } from "@mui/material";
import React, { forwardRef, useEffect, useState } from "react";
import FormDatosCliente from "./components/FormDatosCliente";
import { ModalInfo } from "../folio-de-venta/components/ModalInfo";

const DatosCliente = forwardRef(function DatosCliente(
  { nextStep, prevStep, showToast, hidden, datosCompra, ...props },
  ref
) {
  //Modal de productos
  const [isOpenModalInfo, setIsOpenModalInfo] = useState(false);

  useEffect(() => {
    //Evaluamos la lista de productos
    if (datosCompra && datosCompra.length > 0) {
      setIsOpenModalInfo(true);
    }
  }, [datosCompra]);

  return (
    <div hidden={hidden}>
        <Slide direction="left" in={!hidden} timeout={200}>
          <Box
            component="form"
            noValidate
            autoComplete="off"
            sx={{
              display: "flex",
              justifyContent: "end",
              p: 0,
            }}
          >
            <FormDatosCliente
              ref={ref}
              isActiveScreen={!hidden}
              nextStep={nextStep}
              prevStep={prevStep}
              showToast={showToast}
              {...props}
            />
            <ModalInfo
              isOpenModalInfo={isOpenModalInfo}
              handleCloseModalInfo={() => setIsOpenModalInfo(false)}
              datosCompra={datosCompra}
            />
          </Box>
        </Slide>
    </div>
  );
});

export default DatosCliente;
